import React from 'react';
import {Flex, Icon, Input, PriorityIcon} from '@priority-software/priority-style-react';
import withClickOutside from 'react-onclickoutside';
import {withKeys} from '../../../../components/Common/HOC/withKeys';

const TitleInputComp = ({filtersCounter, onSave, onClear, onChange, value}) => {
    return (
        <div className="flex-container title-input-wrapper">
            <Icon icon={PriorityIcon.filter} skin="standart" counterValue={filtersCounter} />
            <Input
                autoFocus
                skin="line"
                size="large"
                componentClasses="title-input"
                onChange={onChange}
                value={value}
            >
                <Flex inline>
                    {value && (
                        <Icon icon={PriorityIcon.closeSmall} skin="standart" onClick={onClear} />
                    )}

                    <Icon icon={PriorityIcon.roundCheck} onClick={onSave} iconColor="primary-500" />
                </Flex>
            </Input>
        </div>
    );
};

const EnhancedTitleInput = withClickOutside(withKeys(TitleInputComp));

export default EnhancedTitleInput;
